/**
 *
 *  EmailPreferences/Setters/Template
 *
 */

import React from 'react'

// NPM Libraries
import PropTypes from 'prop-types'

// Graphql
import { gql, useMutation } from '@apollo/client'

// Utils
import { notify } from 'utils/notify'

const UPDATE_COMMUNICATION_PREFERENCE = gql`
	mutation updateCommunicationPreference($id: ID!, $email_template_defaults: JSON) {
		updateCommunicationPreference(input: { id: $id, email_template_defaults: $email_template_defaults }) {
			communication_preference {
				id
				email_template_defaults
			}
		}
	}
`

function TemplateSetter({
	communication_preference: { id, email_template_defaults } = {},
	template,
	templates,
	disabled,
}) {
	const [mutate] = useMutation(UPDATE_COMMUNICATION_PREFERENCE, {
		onCompleted: ({ updateCommunicationPreference }) => {
			const selected_template_id =
				updateCommunicationPreference.communication_preference.email_template_defaults[template.template_index]

			if (!selected_template_id) {
				notify({
					message: `Default Email Template selected for ${template.email_template_name}`,
				})
			} else {
				const selected_template_name = templates.find((t) => t.id === selected_template_id).name

				notify({
					message: `${selected_template_name} selected for ${template.email_template_name}`,
				})
			}
		},
	})

	const updateEmailTemplateDefaults = () => {
		if (disabled) return

		const new_email_template_defaults = { ...email_template_defaults }

		if (template.global_default) {
			delete new_email_template_defaults[template.template_index]
		} else {
			new_email_template_defaults[template.template_index] = template.id
		}

		mutate({
			variables: {
				id,
				email_template_defaults: new_email_template_defaults,
			},
		})
	}

	return (
		<div className={disabled ? '' : 'clickable'} onClick={updateEmailTemplateDefaults} style={{ flex: 1 }}>
			<span className="custom-control custom-radio custom-control-inline mb-0 mr-0">
				<input
					id={template.id}
					type="radio"
					className="custom-control-input"
					name={template.template_index}
					value={template.id}
					checked={Boolean(template.default)}
					disabled={!template.has_html || disabled}
				/>
				<span className="custom-control-label">&nbsp;</span>
			</span>

			<span
				className={template.global_default ? 'text-muted' : ''}
				style={template.global_default ? { fontStyle: 'oblique' } : {}}
			>
				{template.name}
			</span>
		</div>
	)
}

TemplateSetter.propTypes = {
	communication_preference: PropTypes.object,
	template: PropTypes.object,
	templates: PropTypes.array,
	disabled: PropTypes.bool,
}

export default TemplateSetter
